import { createAsyncThunk } from "@reduxjs/toolkit";
import apiCall from "../AuthorizedApi";
import { BranchProfile, CreateBranchProfilePayload, UpdateBranchProfilePayload } from "../../../Data/branch.dto";

export const getBranchesAPI = createAsyncThunk<BranchProfile[], number | null | void>(
  "branch/getBranchesAPI",
  async (branchId, { rejectWithValue }) => {
    try {
      const query = branchId ? `?branch_id=${branchId}` : "";
      const response = await apiCall({
        method: "GET",
        url: `/account/branch-profile/${query}`,
      });
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || error?.message || "Failed to fetch branches");
    }
  }
);

export const createBranchAPI = createAsyncThunk(
  "branch/createBranchAPI",
  async (data: CreateBranchProfilePayload, { rejectWithValue }) => {
    try {
      const response = await apiCall({
        method: "POST",
        url: "/account/branch-profile/",
        headers: {
          "Content-Type": "application/json",
        },
        data,
      });
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || error?.message || "Failed to create branch");
    }
  }
);

export const updateBranchAPI = createAsyncThunk<BranchProfile, UpdateBranchProfilePayload>(
  "branch/updateBranchAPI",
  async (data, { rejectWithValue }) => {
    try {
      const response = await apiCall({
        method: "PUT",
        url: "/account/branch-profile/",
        headers: {
          "Content-Type": "application/json",
        },
        data,
      });
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || error?.message || "Failed to update branch");
    }
  }
);

export const deleteBranchAPI = createAsyncThunk<number, number>(
  "branch/deleteBranchAPI",
  async (branchId, { rejectWithValue }) => {
    try {
      await apiCall({
        method: "DELETE",
        url: `/account/branch-profile/?branch_id=${branchId}`,
      });
      return branchId;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || error?.message || "Failed to delete branch");
    }
  }
);

